import React, { Component } from 'react';
import { Cell, Grid ,Dialog, Button} from 'react-md';
import { SegmentedControl } from 'segmented-control';
import SecureShow from '../component/SecureShow';
import ViewQuestionBankArchive from '../component/ViewQuestionBankArchive';
import ViewScoreArchives from '../component/ViewScoreArchive';
import '../css/archive.css';
import '../css/Dashboard.css';
import GradeBook from '../pages/GradebookPage';
import PerfGraphs from '../pages/PerfGraphs';
import { AppProperties } from '../common/function';







export default class ArchivePage extends Component{

    appProperties = AppProperties();

    constructor(props){
        super(props);
        this.state = {
            archiveInProgress:false,
            showGradeBook:false,
            showMissingSemesterDialog : false,
        };
    }

    

    //Event Handlers
    tabOnChange =(clickedValue) =>{
        console.debug("tabOnChange : "+clickedValue);
        if(clickedValue === 'gradebook'){
            this.setState({showGradeBook:true,showViewScore:false,showQuestionBank:false,showPerformanceAnalytics:false});
        }
        if(clickedValue === 'viewScore'){
            this.setState({showGradeBook:false,showViewScore:true,showQuestionBank:false,showPerformanceAnalytics:false});
        }

        if(clickedValue === 'question'){
            this.setState({showGradeBook:false,showViewScore:false,showQuestionBank:true,showPerformanceAnalytics:false});
        }

        if(clickedValue === 'performanceAnalytics'){
            this.setState({showGradeBook:false,showViewScore:false,showQuestionBank:false,showPerformanceAnalytics:true});
        }

        
    }

    handleMissingSemester =()=>{
        this.setState(prevState => ({
            showMissingSemesterDialog: !prevState.showMissingSemesterDialog
        }));
    }

    render(){
        return  <SecureShow targetRole={1} >
                    <Grid gutter={1} className="gradeBookPageContainer">
                        <Cell size={8}><h1>Archive</h1></Cell>
                        <Cell size={10}>
                            <SegmentedControl
                                name="archive-tabs"
                                style={{color: '#bb0000'}}
                                options={[
                                    { label: 'Archived '+(this.appProperties.eqmMode?'Result':'Raw Data'), value: 'viewScore', default: true },
                                    { label: 'Archived Gradebooks', value: 'gradebook' },
                                    { label: 'Archived Questions', value: 'question' },
                                    { label: 'Archived Performance Analytics', value: 'performanceAnalytics' }
                                ]}
                                setValue={newValue => this.tabOnChange(newValue)}
                            />
                        </Cell>
                        
                        {
                             this.state.showGradeBook?
                             <Cell size={12} className="gradebook-cell">   
                                <GradeBook archiveMode={true}/>
                            </Cell>
                            :
                            undefined
                        }
                        {
                            this.state.showViewScore?
                            <Cell size={12} className="gradebook-cell"> 
                                <a onClick={this.handleMissingSemester} id='missing-semester-link'>missing semester?</a>
                                <div  id="missing-semester-dialog">
                                {this.state.showMissingSemesterDialog && (
                                <Dialog 
                                title="Missing Semester"
                                visible={this.state.showMissingSemesterDialog}
                                modal={true}
                                width={'50%'}
                                id='missing-semester-dialog-content'
                                >
                                    <div style={{ width: '100%' }}>
                                    <h2>Need to archive semester</h2>
                                    <p>1. Go to settings</p>
                                    <p>2. Go to semester table</p>
                                    <p>3. In actions, select archive button</p>
                                    <div id ="missing-semester-dialog-footer">
                                    <Button id="missing-semester-close" onClick={this.handleMissingSemester}>
                                    Close
                                    </Button>
                                    </div>
                                    </div>
                                </Dialog>
                                )}

                                </div>  
                               <ViewScoreArchives archiveMode={true}/>
                           </Cell>
                           :
                           undefined
                            
                        }

                        {
                            this.state.showQuestionBank?
                            <Cell size={12} className="gradebook-cell">   
                               <ViewQuestionBankArchive replaceBreadCrumb={this.props.replaceBreadCrumb} archiveMode={true}/>
                           </Cell>
                           :
                           undefined
                            
                        }    

                        {
                            this.state.showPerformanceAnalytics?
                            <Cell size={12} className="gradebook-cell">   
                               <PerfGraphs replaceBreadCrumb={this.props.replaceBreadCrumb} archiveMode={true}/>
                           </Cell>
                           :
                           undefined
                            
                        }       
                        
                    </Grid>
                </SecureShow>
    }
}

